import React, { PureComponent } from 'react'
import { paymentMethodPropType } from '../../common/paymentMethodTypes'
import SavedECheck from './components/SavedECheck'
import SavedEUDD from './components/SavedEUDD'

class SavedECheckEUDD extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
  }

  render() {
    const { paymentMethod } = this.props
    const payemtType = paymentMethod['@type']
    if (payemtType === 'ECheckPaymentMethod') {
      return <SavedECheck paymentMethod={paymentMethod} />
    } if (payemtType === 'EUDDPaymentMethod') {
      return <SavedEUDD paymentMethod={paymentMethod} />
    }
    return null
  }
}

export default SavedECheckEUDD
